// Adapted from pagila-rails-portal/app/javascript/coreui/dom.js
export function normalizeData(value) {
  if (value === "" || value === "true") return true
  if (value === "false") return false
  if (value === "null") return null
  if (value !== "" && Number.isFinite(Number(value))) return Number(value)

  if ((value.startsWith("[") && value.endsWith("]")) || (value.startsWith("{") && value.endsWith("}"))) {
    try {
      return JSON.parse(value)
    } catch {
      // Comma-separated demo values are intentionally left as strings.
    }
  }

  return value
}

export function dataConfig(element) {
  const config = Object.entries(element.dataset).reduce((config, [key, value]) => {
    if (!key.startsWith("coreui")) return config

    const option = key.slice(6)
    if (!option) return config

    config[option[0].toLowerCase() + option.slice(1)] = normalizeData(value)
    return config
  }, {})
  const merged = { ...(typeof config.config === "object" ? config.config : {}), ...config }
  for (const key of ["sanitize", "allowList", "sanitizeFn"]) delete merged[key]
  return merged
}

export function dispatch(element, name, detail = {}, { cancelable = false } = {}) {
  const event = new CustomEvent(name, { bubbles: true, cancelable, detail })
  element.dispatchEvent(event)
  return event
}


export function parseList(value) {
  if (Array.isArray(value)) return value
  if (value === null || value === undefined || value === false) return []
  return String(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
}

